(() => {
  const DESKTOP_MIN = 1000;

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function getHeaderOffset() {
    const rawValue = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .trim();

    const parsed = parseFloat(rawValue);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function extractPrice(text) {
    const clean = cleanText(text);
    const match = clean.match(/(\d{1,3}(?:\.\d{3})*,\d{2}\s*€|\d+(?:,\d{2})\s*€|\€\s*\d[\d.,]*)/);
    if (!match) return '';
    return cleanText(match[0]).replace(/^€\s*/, '') + (match[0].includes('€') ? '' : '€');
  }

  function getSection(sectionId) {
    return (
      document.querySelector(`section[data-section-id="${sectionId}"][data-section-type="product"]`) ||
      document.querySelector(`section[data-section-id="${sectionId}"]`)
    );
  }

  function getTabsMenu(section) {
    return section ? section.querySelector('.product-layout-v2__bottom-item--description .tabs-menu-product') : null;
  }

  function getDescriptionBlock(section) {
    return section ? section.querySelector('.product-layout-v2__bottom-item--description') : null;
  }

  function getForm(formId) {
    return formId ? document.getElementById(formId) : null;
  }

  function getMainButton(section, formId) {
    const form = getForm(formId);
    if (form) {
      const button = form.querySelector('.product-form__add-button');
      if (button) return button;
    }

    return section ? section.querySelector('.product-form__add-button') : null;
  }

  function getPriceText(section) {
    if (!section) return '';

    const infoColumn = section.querySelector('.product-layout-v2__info');
    if (!infoColumn) return '';

    const selectors = [
      '.price-list .price--highlight',
      '.price--highlight',
      '.price-list .price',
      '.product-meta__price-list',
      '.price-list',
      '.price'
    ];

    for (const selector of selectors) {
      const node = infoColumn.querySelector(selector);
      if (!node) continue;

      const extracted = extractPrice(node.textContent);
      if (extracted) return extracted;
    }

    return '';
  }

  function scrollToTabContent(descriptionBlock, tabName) {
    if (!descriptionBlock) return;

    const safeTabName =
      window.CSS && typeof window.CSS.escape === 'function'
        ? window.CSS.escape(tabName)
        : tabName;

    const target =
      descriptionBlock.querySelector(`.tab-content#${safeTabName}`) ||
      descriptionBlock.querySelector('.tab-content.active') ||
      descriptionBlock;

    if (!target) return;

    const stickyBar = document.querySelector('[data-product-sticky-desktop].is-visible');
    const stickyHeight = stickyBar ? stickyBar.offsetHeight : 0;
    const offset = getHeaderOffset() + stickyHeight + 14;

    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  }

  function initStickyDesktopBar(bar) {
    if (!bar || bar.dataset.stickyDesktopInit === 'true') return;

    const sectionId = bar.dataset.sectionId;
    const formId = bar.dataset.productFormId;
    const tabsContainer = bar.querySelector('[data-sticky-tabs]');
    const stickyBuyButton = bar.querySelector('[data-sticky-buy-button]');
    const stickyBuyLabel = bar.querySelector('[data-sticky-buy-label]');

    if (!sectionId || !tabsContainer || !stickyBuyButton || !stickyBuyLabel) return;

    let section = null;
    let tabsMenu = null;
    let descriptionBlock = null;
    let mainButton = null;

    let sectionObserver = null;
    let tabsObserver = null;
    let buttonObserver = null;

        let indicatorFrame = null;

    function updateStickyIndicator() {
      const activeTab = tabsContainer.querySelector(
        '.product-sticky-desktop-bar__tab.is-active'
      );

      if (!activeTab || !tabsContainer.getClientRects().length) {
        tabsContainer.style.setProperty(
          '--sticky-indicator-visible',
          '0'
        );
        return;
      }

      const range = document.createRange();
      range.selectNodeContents(activeTab);

      const textRect = range.getBoundingClientRect();
      const containerRect = tabsContainer.getBoundingClientRect();

      if (!textRect.width) return;

      const x =
        textRect.left -
        containerRect.left -
        tabsContainer.clientLeft +
        tabsContainer.scrollLeft;

      tabsContainer.style.setProperty(
        '--sticky-indicator-x',
        `${x}px`
      );

      tabsContainer.style.setProperty(
        '--sticky-indicator-width',
        `${textRect.width}px`
      );

      tabsContainer.style.setProperty(
        '--sticky-indicator-visible',
        '1'
      );

      /* Colocar la línea sin animación en la primera carga */
      if (!tabsContainer.classList.contains('has-sticky-indicator')) {
        void tabsContainer.offsetWidth;
        tabsContainer.classList.add('has-sticky-indicator');
      }
    }

    function scheduleStickyIndicator() {
      cancelAnimationFrame(indicatorFrame);
      indicatorFrame = requestAnimationFrame(updateStickyIndicator);
    }

    const indicatorResizeObserver = new ResizeObserver(
      scheduleStickyIndicator
    );

    indicatorResizeObserver.observe(tabsContainer);

    if (document.fonts) {
      document.fonts.ready.then(scheduleStickyIndicator);
    }

    function resolveNodes() {
      section = getSection(sectionId);
      tabsMenu = getTabsMenu(section);
      descriptionBlock = getDescriptionBlock(section);
      mainButton = getMainButton(section, formId);
    }

    function updateVisibility() {
      resolveNodes();

      if (window.innerWidth < DESKTOP_MIN || !tabsMenu) {
        bar.classList.remove('is-visible');
        return;
      }

      if (window.getComputedStyle(tabsMenu).display === 'none') {
        bar.classList.remove('is-visible');
        return;
      }

      const rect = tabsMenu.getBoundingClientRect();
      const shouldShow = rect.bottom <= (getHeaderOffset() + 8);

      bar.classList.toggle('is-visible', shouldShow);
    }

       function syncActiveTab() {
      if (!tabsMenu) return;

      const activeRealTab = tabsMenu.querySelector(
        '.tab-link.active[data-tab]'
      );

      const activeName = activeRealTab
        ? activeRealTab.getAttribute('data-tab')
        : '';

      tabsContainer
        .querySelectorAll(
          '.product-sticky-desktop-bar__tab[data-sticky-tab]'
        )
        .forEach((button) => {
          button.classList.toggle(
            'is-active',
            button.getAttribute('data-sticky-tab') === activeName
          );
        });

      scheduleStickyIndicator();
    }

    function buildStickyTabs() {
      resolveNodes();
      tabsContainer.innerHTML = '';

      if (!tabsMenu) return;

      const realTabs = Array.from(tabsMenu.querySelectorAll('.tab-link[data-tab]'));

      realTabs.forEach((realTab) => {
        const tabName = realTab.getAttribute('data-tab');
        const tabLabel = cleanText(realTab.textContent);

        if (!tabName || !tabLabel) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-sticky-desktop-bar__tab';
        button.setAttribute('data-sticky-tab', tabName);
        button.textContent = tabLabel;

        button.addEventListener('click', () => {
          const linkedRealTab = tabsMenu ? tabsMenu.querySelector(`.tab-link[data-tab="${tabName}"]`) : null;
          if (!linkedRealTab) return;

          linkedRealTab.click();

          requestAnimationFrame(() => {
            syncActiveTab();

            setTimeout(() => {
              scrollToTabContent(descriptionBlock, tabName);
            }, 80);
          });
        });

        tabsContainer.appendChild(button);
      });

      syncActiveTab();
    }

    function syncBuyButton() {
      resolveNodes();

      if (!mainButton) return;

      const disabled = mainButton.disabled;
      const realLabel = cleanText(mainButton.textContent);
      const price = getPriceText(section);

      stickyBuyButton.disabled = disabled;
      stickyBuyButton.classList.toggle('button--disabled', disabled);
      stickyBuyButton.classList.toggle('button--primary', !disabled);

      if (!disabled && price) {
        stickyBuyLabel.innerHTML = `
          <span class="product-sticky-desktop-bar__buy-prefix">Comprar por</span>
          <span class="product-sticky-desktop-bar__buy-price">${price}</span>
        `;
      } else if (realLabel) {
        stickyBuyLabel.textContent = realLabel;
      }
    }

    stickyBuyButton.addEventListener('click', (event) => {
      event.preventDefault();

      resolveNodes();

      if (!mainButton || mainButton.disabled) return;

      mainButton.click();
    });

    function bindObservers() {
      if (tabsObserver) tabsObserver.disconnect();
      if (buttonObserver) buttonObserver.disconnect();
      if (sectionObserver) sectionObserver.disconnect();

      if (tabsMenu) {
        tabsObserver = new MutationObserver(() => {
          buildStickyTabs();
          syncActiveTab();
          updateVisibility();
        });

        tabsObserver.observe(tabsMenu, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (mainButton) {
        buttonObserver = new MutationObserver(() => {
          syncBuyButton();
        });

        buttonObserver.observe(mainButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (section) {
        sectionObserver = new MutationObserver(() => {
          buildStickyTabs();
          syncBuyButton();
          updateVisibility();
          bindObservers();
        });

        sectionObserver.observe(section, {
          childList: true,
          subtree: true
        });
      }
    }

    resolveNodes();
    buildStickyTabs();
    syncBuyButton();
    updateVisibility();
    bindObservers();

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    bar.dataset.stickyDesktopInit = 'true';
  }

  function initAllStickyDesktopBars() {
    document
      .querySelectorAll('[data-product-sticky-desktop]')
      .forEach(initStickyDesktopBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyDesktopBars);
  } else {
    initAllStickyDesktopBars();
  }

  document.addEventListener('shopify:section:load', initAllStickyDesktopBars);
})();